/**
 * Turns the edge's machine-readable failure reason into something an operator
 * can act on.
 *
 * The reasons originate in `edge/clip-compilation-edge.ts` and are stored
 * verbatim on the job, so this is the only place they become prose. Anything
 * unrecognised falls through to the raw string rather than being hidden — a
 * reason we have not mapped yet is still more use than no reason at all, and
 * silently swallowing it is how these end up undiagnosable.
 */
export function failureReasonLabel(reason: string | undefined): string | undefined {
  if (!reason) return undefined;

  switch (reason) {
    case "before_tenancy_start":
      return "Requested range starts before this asset was deployed to your site";
    case "no_recordings":
      return "No recordings found in the requested range";
    case "no_valid_segments":
      return "Recordings were found but none could be exported";
    case "camera_not_found":
      return "Camera is no longer installed on this asset";
    case "camera_unreachable":
      return "Camera could not be reached";
    case "disk_full":
      return "Not enough space on the device to build the compilation";
    case "invalid date range":
      return "Requested range is invalid";
    case "compilation already in progress":
      return "Another compilation was already running for this camera";
    default:
      // `too_many_recordings: 3000 found, max 2000` carries its own numbers, so
      // it reads well enough with only the prefix tidied up.
      if (reason.startsWith("too_many_recordings:")) {
        return `Too many recordings in the requested range — ${reason.slice("too_many_recordings:".length).trim()}`;
      }
      return reason;
  }
}
